<template>
    <div>
        <div class="table-pagination">
            <ModelSwitch
                v-if="isSuper"
                label="Спорные оценки"
                v-model="showOnlyNeedFeedback"
                @change="updateFilter"
            />
            <div v-else></div>
            <Pagination
                :max="maxPage"
                :value="currentPage"
                :pageSize="currentPageSize"
                @input="updateCurrentPage"
                show-per-page
                @inputPageSize="updatePageSize"
            />
        </div>

        <div class="table-wrap">
            <ExpertPanelTable
                :columns="columns"
                :rows="rows"
                @click="select"
                :filter="inputFilter"
                @updateFilter="updateFilter"
                @select="selected = $event"
            />
        </div>

    </div>
</template>

<script>
import Pagination from "@/components/UI/Pagination.vue";
import ExpertPanelTable from "@/components/expert-panel-new/tables/ExpertPanelTable.vue";
import {rusDateTime} from "@/tools/date_format";
import FilterInput from "@/components/expert-panel-new/tables/filters/FilterInput.vue";
import ModelSwitch from "@/components/UI/models/ModelSwitch.vue";
import getApi from "@/tools/api/examination";
import FilterRange from "@/components/expert-panel-new/tables/filters/FilterRange.vue";

export default {
    name: "ExpertPanelTableCompleted",
    components: {ModelSwitch, ExpertPanelTable, Pagination},
    props: {
        rows: Array,
        currentPage: Number,
        currentPageSize: Number,
        total: Number,
        isSuper: Boolean,
        needFeedback: Number,
        review: Object,
        filter: Object,
    },
    computed: {
        maxPage() {
            return this.$store.getters['examination/pagesCount'](this.total, this.currentPageSize);
        },
        columns() {
            return [
                {
                    id: 'id',
                    name: 'ID работы',
                    value: (row) => row.id,
                    visible: true,
                    infoBadge: (row) => row.status === 'need_feedback' && this.isSuper,
                    filter: {
                        type: FilterInput,
                        params: {
                            alias: 'id',
                            name: 'ID работы',
                        },
                    },
                },
                {
                    id: 'userId',
                    name: 'ID участника',
                    value: (row) => row.userId,
                    visible: !(this.review && this.review.isAnonymous),
                    filter: {
                        type: FilterInput,
                        params: {
                            alias: 'userId',
                            name: 'ID участника',
                        },
                    },
                },
                {
                    id: 'fio',
                    name: 'ФИО участника',
                    value: (row) => row.fio,
                    visible: !(this.review && this.review.isAnonymous),
                },
                {
                    id: 'phone',
                    name: 'Телефон',
                    value: (row) => row.phone,
                    visible: !(this.review && this.review.isAnonymous),
                },
                {
                    id: 'date',
                    name: 'Дата решения',
                    value: (row) => rusDateTime(row.readyForReviewAt),
                    visible: true,
                },
                {
                    id: 'score',
                    name: 'Баллы',
                    value: (row) => row.score,
                    visible: this.isSuper,
                    filter: {
                        type: FilterRange,
                        params: {
                            alias: 'score',
                            name: 'Баллы',
                        },
                    },
                },
            ].filter((column) => column.visible);
        },
    },
    data() {
        return {
            showOnlyNeedFeedback: false,
            inputFilter: {...this.filter},
            examinationApi: getApi(),
        };
    },
    watch: {
        filter() {
            this.inputFilter = {...this.filter};
        },
    },
    methods: {
        select(activitySession) {
            if (this.review.activityType === 'task') {
                this.$router.push(`/expert-panel/review/${this.$route.params.event}/${activitySession.id}${this.isSuper ? '/super' : ''}`);
            } else {
                this.$router.push(`/expert-panel/old/review/${this.$route.params.event}/${activitySession.id}`);
            }
        },
        updateCurrentPage(newPage) {
            this.$emit('update-current-page', newPage);
        },
        updatePageSize(newPageSize) {
            this.$emit('update-page-size', newPageSize);
        },
        updateFilter(filter) {
            this.$emit('update-filter', {
                ...filter,
                onlyNeedFeedback: this.showOnlyNeedFeedback,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.table {
  &-wrap {
    margin-top: rem(16);
    &__actions {
      text-align: right;
      margin-top: rem(54);
    }
  }
  &-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .labeled {
      font-family: Montserrat, sans-serif;
      font-weight: 600;
      font-size: rem(16);
      color: #2A2626;
      margin-bottom: 0;
    }
    :deep(.ui-switch-other) {
      margin-right: rem(6);
    }
  }
}
.confirm-dialog {
  :deep(.dialog) {
    max-width: rem(680);
  }
  &__title {
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(30);
    text-align: center;
    color: #000000;
    margin-bottom: rem(16);
  }
  &__title2 {
    font-style: normal;
    font-weight: 600;
    font-size: rem(24);
    line-height: rem(34);
    text-align: center;
    color: #000000;
    margin-bottom: rem(24);
  }
  &__text {
    font-weight: 500;
    font-size: rem(16);
    line-height: rem(22);
    color: #2A2626;
    text-align: center;
    margin-bottom: rem(40);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: rem(6);
  }
  &__footer {
    display: flex;
    justify-content: center;
    gap: rem(22);
    :deep(.rsv-button_color_white) {
      padding: rem(14) rem(32);
      background: #fff;
      border: solid 1px #4663AB;
      color: #4663ab;
      border-radius: rem(10);
    }
  }
}
</style>